const translations = {
  title: 'Atividades Dinâmicas',
  name: 'Nome',
  checklist: 'Questionário',
  place: 'Destino',
  cardsView: 'Visão de cards (em breve)',
  selectPlace: 'Selecione um destino',
  lockReasons: 'Motivos de bloqueio',
  successTitle: 'Atividade respondida com sucesso!',
  successBody: 'As respostas já foram enviadas!'
}

export default translations
